import { usePunditUserContext } from "@/react/contexts";

export const useIsGlobalThemingEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.builder_global_theming_enabled);
};
